function initializeDropdownMenu() {
  const $dropdown = $('.l-header__menu__item');
  const $dropdownMenu = $dropdown.find('.l-header__menu__item__dropdown');

  // 既存のイベントリスナーを削除してから新しく追加
  $dropdown.off('click');
  $(window).off('click.dropdown');

  $dropdown.on('click', (e) => {
    e.stopPropagation();
    if ($dropdownMenu.is(':visible')) {
      $dropdownMenu.hide();
    } else {
      $dropdownMenu.show();
    }
  });

  // Dropdown menuを閉じる処理
  $(window).on('click.dropdown', () => {
    $dropdownMenu.hide();
  });
}

// 初期ロード時とTurbo遷移時の両方に対応
document.addEventListener('turbo:load', initializeDropdownMenu);
